import React from 'react';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

const CHAT_REMARK_PLUGINS = [remarkGfm];

export type ChatMarkdownProps = {
  readonly text: string;
};

export function ChatMarkdown(props: ChatMarkdownProps): React.ReactElement {
  return (
    <div className="chat-markdown">
      <Markdown remarkPlugins={CHAT_REMARK_PLUGINS} skipHtml>
        {props.text}
      </Markdown>
    </div>
  );
}
